import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyVisitorList = createAsyncThunk(
  "societyVisitorList",
  async () => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/dashboard/visitor-list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);
const initialState = {
  isLoading: false,
  societyVisitorListData: null,
  isError: false,
  errorMessage: "",
};

const societyVisitorListSlice = createSlice({
  name: "societyVisitorList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyVisitorList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyVisitorList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyVisitorListData = action.payload;
    });
    builder.addCase(societyVisitorList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyVisitorListSlice.reducer;